module.exports = __webpack_public_path__ + "img/header-engagementRingsModern.309749f.jpg";